import { ConnectedRouter } from 'connected-react-router';
import React, { memo, ReactElement } from 'react';
import { Provider } from 'react-redux';

import ToasterContainer from 'components/molecules/toaster/container';
import { WebviewerContextProvider } from 'components/organisms/reusableWebviewer';
import VersionChecker from 'components/organisms/versionChecker';
import { DepsProvider } from 'container/depContext';
import { serviceFactory } from 'container/serviceFactory';

import configureStore, { history } from './redux/configureStore';
import AppRoutes from './routes';

export const appStore = configureStore();

function AppRoot(): ReactElement {
  return (
    <Provider store={appStore}>
      <VersionChecker />
      <DepsProvider serviceFactory={serviceFactory}>
        <WebviewerContextProvider>
          <ConnectedRouter history={history}>
            <ToasterContainer />
            <AppRoutes />
          </ConnectedRouter>
        </WebviewerContextProvider>
      </DepsProvider>
    </Provider>
  );
}

export default memo(AppRoot);
